// extracted by mini-css-extract-plugin
module.exports = {"Models":"Slider_Models__F0YK_","Items":"Slider_Items__6zjQq","Item":"Slider_Item__ss6X1"};